import uiUserWrapperList from './user-wrapper-list/index.vue'
import uiReserveWrapperList from './reserve-wrapper-list/index.vue'
import uiActionsDealsWrapperList from './actions-deals-wrapper-list/index.vue'
import uiCustomersWrapperList from './customers-wrapper-list/index.vue'

export {
    uiUserWrapperList,
    uiReserveWrapperList,
    uiActionsDealsWrapperList,
	uiCustomersWrapperList,
}
